import { skinsState } from './ggPlaySkins.js'

// Live Skins panel — mirrors the Scats panel: 💰 Skins title + GROSS/NET tag,
// the current-hole winner/tie/carry line, and a per-player skins + running $
// table. Renders only when meta.addons.skins is enabled + viable.
const row = { display: 'flex', justifyContent: 'space-between', fontSize: 16, padding: '3px 0' }
const money = (v) => (Math.round(v) === 0 ? '$0' : v > 0 ? `+$${Math.round(v)}` : `−$${Math.round(-v)}`)

export default function GSkinsLive({ game, hole }) {
  const st = skinsState(game, hole)
  if (!st) return null
  const { rows, result, amount, payout, useNet, carry, double } = st
  const players = game.players || []
  const total = result.counts.reduce((a, b) => a + b, 0)
  const w = result.holeWinner[hole - 1]
  const val = result.valueAtHole[hole - 1]
  const first = (i) => players[i]?.name.split(' ')[0]
  const line = typeof w === 'number'
    ? `💰 ${first(w)} won ${val} skin${val === 1 ? '' : 's'} on hole ${hole}!${useNet ? ' (net)' : ''}`
    : w === 'tie'
      ? `➗ Tied on hole ${hole} — ${carry ? (double ? 'stake doubles' : 'skin carries') + ' to the next hole' : 'skin burned'}`
      : `Hole ${hole} — lowest ${useNet ? 'net ' : ''}score wins the skin${result.pending > 1 ? ` · ${result.pending} carried` : ''}`

  return (
    <div style={{ border: '1px solid #F9A825', borderRadius: 12, padding: 12, marginTop: 12, background: '#FFFBEB' }}>
      <div className="flex items-center justify-between mb-1">
        <div className="flex items-center gap-2">
          <span className="font-bold text-sm">💰 Skins</span>
          <span className="text-[10px] font-bold px-2 py-0.5 rounded-full" style={{ backgroundColor: useNet ? '#1B7A3E' : '#E5E7EB', color: useNet ? '#fff' : '#374151' }}>{useNet ? 'NET' : 'GROSS'}</span>
          <span className="text-[10px] text-gray-500">${amount}/skin · {payout === 'per-player' ? 'per-player' : 'split-pot'}{carry ? (double ? ' · double carry' : ' · carry') : ' · no carry'}</span>
        </div>
        <span className="text-xs text-gray-600">{total} skin{total === 1 ? '' : 's'} awarded</span>
      </div>
      <div className="text-xs mb-2 rounded px-2 py-1" style={{ background: typeof w === 'number' ? '#DCFCE7' : w === 'tie' ? '#FEF3C7' : '#fff', border: '1px solid #E5E7EB', fontWeight: (typeof w === 'number' || w === 'tie') ? 700 : 400, color: typeof w === 'number' ? '#166534' : w === 'tie' ? '#92400E' : '#6B7280' }}>{line}</div>
      <div>
        {rows.map((r) => (
          <div key={r.id} style={{ ...row, opacity: r.in ? 1 : 0.5 }}>
            <span>{r.name}{!r.in ? ' (out)' : ''}</span>
            <span><b>{r.skins}</b> skin{r.skins === 1 ? '' : 's'}<b className="ml-3" style={{ color: r.net > 0 ? '#1B7A3E' : r.net < 0 ? '#B42318' : '#888' }}>{money(r.net)}</b></span>
          </div>
        ))}
      </div>
    </div>
  )
}
